import React, { useEffect, useRef, useState } from "react";
import Carousel from "segments/desktop/core-components/carousel/carousel";
import classnames from "classnames";
import { componentStyles } from "./building-blocks-tabs-mobile-component.scss";
import BuildingBlocksTabContentComponent from "../building-blocks-tab-content/building-blocks-tab-content-component";

const CAROUSEL_LEFT_SWIPE = "left";
const CAROUSEL_RIGHT_SWIPE = "right";

const BuildingBlocksTabsMobileComponent = (props) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [carouselRef, setCarouselRef] = useState(null);
  const itemsRef = useRef([]);
  const { tabs, buildingBlocksTabsTheme } = props;

  const tabsWithVideoPlayerRefs = [];
  tabs.forEach((tab) => {
    tabsWithVideoPlayerRefs.push({
      ...tab,
      videoPlayerRef: useRef(null)
    });
  });

  useEffect(() => {
    itemsRef.current = itemsRef.current.slice(0, tabsWithVideoPlayerRefs.length);
  }, [tabsWithVideoPlayerRefs]);

  useEffect(() => {
    const currentTab = tabsWithVideoPlayerRefs[selectedTab];
    if (currentTab?.videoPlayerRef?.current) {
      currentTab.videoPlayerRef.current.seekTo(0);
    }
  }, [selectedTab]);

  const itemRenderer = (tab, index) => {
    return (
      <BuildingBlocksTabContentComponent
        key={index}
        tab={tab}
        buildingBlocksTabsTheme={buildingBlocksTabsTheme}
        themeColor={buildingBlocksTabsTheme}
        isMobileDisplay={true}
      />
    );
  };

  const navItemRenderer = (tab, index) => {
    return (
      <span
        className={classnames("tab-nav-button-wrapper", { selected: selectedTab === index })}
        ref={(element) => (itemsRef.current[index] = element)}
        onClick={() => {
          setSelectedTab(index);
          carouselRef.slickGoTo(index);
        }}
      >
        {tab.tabLabel}
      </span>
    );
  };

  const carouselProps = {
    items: tabsWithVideoPlayerRefs,
    itemRenderer,
    slidesToShow: 1,
    autoplay: false,
    autoplaySpeed: -1,
    centerPadding: "5%",
    centerMode: false,
    infinite: false,
    fade: false,
    onRefSet: setCarouselRef
  };

  const onCarouselChange = (current) => {
    // fix selectedTab index in case of a glitch
    if (current !== selectedTab) {
      setSelectedTab(current);
      itemsRef?.current?.[current]?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
    }
  };

  const onCarouselSwipe = (direction) => {
    let newSlide = selectedTab;
    if (direction === CAROUSEL_LEFT_SWIPE && selectedTab < tabs.length - 1) {
      newSlide = selectedTab + 1;
    }
    if (direction === CAROUSEL_RIGHT_SWIPE && selectedTab > 0) {
      newSlide = selectedTab - 1;
    }
    setSelectedTab(newSlide);
    itemsRef?.current?.[newSlide]?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
  };

  return (
    <div className="building-blocks-tabs-mobile-component">
      <div className="building-blocks-tabs-mobile-navigation">
        {tabsWithVideoPlayerRefs.map((tab, index) => navItemRenderer(tab, index))}
      </div>
      <div className="carousel-wrapper">
        <Carousel {...carouselProps} onChange={(current) => onCarouselChange(current)} onSwipe={onCarouselSwipe} />
      </div>
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default BuildingBlocksTabsMobileComponent;
